import { type ReactElement, type ReactNode, useEffect } from "react"
import { EndUserInstanceType } from "../../types/EndUserInstanceType"
import { useSelector } from "react-redux";
import { RootState } from "src/app/store";
import Modal from "src/components/Modal";
import { useForm, SubmitHandler } from "react-hook-form";
import Button from "src/components/Button";
import Saving from "src/components/Saving";

export interface EndUserInstanceModalProps {
        title: string,
        isOpen: boolean,
        selectedEndUserInstance: EndUserInstanceType | undefined,
        onClose: () => void,
        onSubmit: (value: EndUserInstanceType) => void,
        endUserID: string,
        children?: ReactNode
}

export default function EndUserInstanceModal(props: EndUserInstanceModalProps): ReactElement {
        const { register, handleSubmit, reset, clearErrors, setError, formState: { errors, isSubmitting } } = useForm<EndUserInstanceType>({
                defaultValues: props.selectedEndUserInstance
        });

        const { authUser } = useSelector((state: RootState) => state.auth);
        const { endUsers } = useSelector((state: RootState) => state.endUsers);
        const { endUserInstanceLoading, endUserInstance, endUserInstanceError } = useSelector((state: RootState) => state.endUserInstance);

        const onSubmit: SubmitHandler<EndUserInstanceType> = (data) => {
                props.onSubmit(data);
        }

        useEffect(() => {
                let error = "";
                reset(props.selectedEndUserInstance);
                if (endUserInstanceError !== null) {
                        error = endUserInstanceError;
                }
                setError("root", {
                        type: "manual",
                        message: error,
                });
        }, [endUserInstanceError])

        const authorized = authUser?.UserType === "admin" ? false : true;

        return <>
                <Modal isOpen={props.isOpen} modalSize="lg" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-4 flex flex-col items-center">
                                        <label className="block text-sm">EndUser Name</label>
                                        <input className="w-full px-3 py-2 border text-center rounded-lg" value={endUsers.find(i => i.Id === Number(props.endUserID))?.Name} disabled={true} />
                                </div>
                                <div className="flex justify-between">
                                        <div className="flex flex-col">
                                                {/*<div className="mb-4">
                                                        <label className="block text-sm">EndUser Instance ID</label>
                                                        <input className="w-full px-3 py-2 border rounded-lg" {...register("EndUserInstanceId", { required: "Id is required" })} />
                                                </div>
                                                {errors.Id && (
                                                        <div className="text-red-500">{errors.Id.message}</div>
                                                )}
						*/}
                                                <div className="mb-4">
                                                        <label className="block text-sm">Name *</label>
                                                        <input className="w-full px-3 py-2 border rounded-lg" {...register("Name", { required: "Name is required" })} />
                                                </div>
                                                {errors.Name && (
                                                        <div className="text-red-500">{errors.Name.message}</div>
                                                )}
                                                <div className="mb-4">
                                                        <label className="block text-sm">Link *</label>
                                                        <input className="w-full px-3 py-2 border rounded-lg" {...register("Link", { required: "Link is required" })} />
                                                </div>
                                                {errors.Link && (
                                                        <div className="text-red-500">{errors.Link.message}</div>
                                                )}
                                        </div>
                                        <div className="flex flex-col">
                                                <div className="mb-4">
                                                        <label className="block text-sm">Number of Doors</label>
                                                        <input className="w-full px-3 py-2 border rounded-lg" disabled={true} {...register("NumberOfDoors")} />
                                                </div>
                                                <div className="mb-4 flex items-center">
                                                        <label className="block flex-auto text-sm">EndUser enabled</label>
                                                        <input type="checkbox" className="w-full flex-[1_0_0] px-3 py-2 border rounded-lg" disabled={true} {...register("Enabled")} />
                                                </div>
                                                <div className="mb-4">
                                                        <label className="block text-sm">Notes</label>
                                                        <input className="w-full px-3 py-2 border rounded-lg" {...register("Notes")} />
                                                </div>
                                        </div>
                                </div>
                                <div className="flex gap-16 justify-around">
                                        <Button className="" size="lg" type="reset" buttonStyle="delete">Reset</Button>
                                        <Button className="" size="lg" type="submit" buttonStyle="primary">
                                                {endUserInstanceLoading ? <Saving title="Saving" color="black" /> : "Save"}
                                        </Button>
                                </div>
                        </form>
                        {errors.root && (
                                <div className="text-red-500 text-center">{errors.root.message}</div>
                        )}
                </Modal>
        </>
}
